import { ExternalLink } from '@augmentt-dev/ui-components'
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

function MicrosoftPortalLinks() {
  const intl = useIntl()

  return (
    <>
      <div className="text-strong mb-4">
        <FormattedMessage id="GENERAL.MICROSOFT_PORTAL_LINKS" />
      </div>
      <div className="text-bold mb-2">
        <ExternalLink
          href="https://admin.microsoft.com"
          label={intl.formatMessage({ id: 'GENERAL.M365_ADMIN_CENTER' })}
        />
      </div>
      <div className="text-bold mb-2">
        <ExternalLink
          href="https://security.microsoft.com"
          label={intl.formatMessage({ id: 'GENERAL.MICROSOFT_DEFENDER' })}
        />
      </div>
      <div className="text-bold mb-2">
        <ExternalLink
          href="https://entra.microsoft.com"
          label={intl.formatMessage({ id: 'GENERAL.MICROSOFT_ENTRA' })}
        />
      </div>
    </>
  )
}

export default MicrosoftPortalLinks
